import React, { useState, useRef, useEffect } from 'react';
import { MapContainer, TileLayer, FeatureGroup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import 'leaflet-draw/dist/leaflet.draw.css';
import { EditControl } from 'react-leaflet-draw';
import L, { latLng } from 'leaflet';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import api from '../../services/api'
import '../Maps/maps.css'
const Maps = () => {
    
  const defaultCenter = [-14.235004, -51.92528];
  const brazilBounds = [
    [-33.747, -73.987],  // Sudoeste do Brasil
    [5.271, -32.392]     // Nordeste do Brasil
  ];
  const [option, setOption] = useState(null);
  const [ceps, setCeps] = useState([]);
  const [userLocation, setUserLocation] = useState(null);
  const [modalState, setModalState] = useState(false);
  const [originalPosition, setOriginalPosition] = useState(null);
  const [loading, setLoading] = useState(true); // Estado de carregamento

  const [layer, setLayer] = useState(null);
  const mapRef = useRef(null);
  const [currentLocationData, setCurrentLocationData] = useState([]);

  const featureGroupRef = useRef(null);

  const addLayerToMap = (data) => {
    // Limpar todas as camadas antes de adicionar novas
    if (featureGroupRef.current) {
      featureGroupRef.current.clearLayers();
    }

    data?.map((item) => {
      const circle = L.circle([item.lat, item.lng], {
        radius: item.radius,
        id: item.id, // Atribuir o id ao círculo

      });

      const marker = L.marker([item.lat, item.lng], {
        icon: L.divIcon({
          html: `
            <div id="data-maker-${item.id}">
              ${item.type_delivery === "1" 
                ? `<img   class="custom-icon" />`
                : `<img  class="custom_icon_jadlog" />`}
            </div>`,
        }),
      });
      const boxMarkerRemove = L.marker([item.lat, item.lng], {
        icon: L.divIcon({
          className: "remove-button",
          html: `
            <button onclick="removeCircle(${item.id});" class="btn-remove-circle-${item.id}" style="background: red; color: white; border: none; border-radius: 50%; cursor: pointer;">X</button>
          `,
        }),
      });


      marker.bindPopup(item.type_delivery === "1" ? "Flex" : "Jadlog").openTooltip();



      const boxMarker = L.marker([item.lat, item.lng], {
        icon: L.divIcon({
          className: `caixa-${item.id}`,
          html: `
            <div class="caixa-conteudo">
              <div>
                <input 
                  type="text" 
                  placeholder="Custo frete" 
                  value="${item.coust_delivery || ''}" 
                  onchange="(function(e) {
                    window.reactOnChangeHandler(e, 'custoFrete', ${item.lat}, ${item.lng}, ${item.id});
                  })(event)"
                  class="input-caixa" 
                />
                <input 
                  type="text" 
                  placeholder="Dias adicionais" 
                  value="${item.adicional_days || ''}" 
                  onchange="(function(e) {
                    window.reactOnChangeHandler(e, 'diasAdicionais', ${item.lat}, ${item.lng}, ${item.id});
                  })(event)" 
                  class="input-caixa" 
                />
              </div>
            </div>
          `,
        }),
      });

      if (featureGroupRef.current) {
        featureGroupRef.current.addLayer(circle);
        featureGroupRef.current.addLayer(marker);
        featureGroupRef.current.addLayer(boxMarker);
        featureGroupRef.current.addLayer(boxMarkerRemove);

      }
    });

    setCurrentLocationData(data); // Salva os dados no estado para edição/exclusão

  };
  const onEdited = async (e) => {
    const layers = e.layers; // Captura as camadas que foram editadas

    layers.eachLayer(async (layer) => {
      if (layer instanceof L.Circle && layer.options.id !== undefined) {
        // Verifica se o layer é um círculo e se ele tem um ID
        const { _latlng, _mRadius, options } = layer;
        const circleId = options.id; // Pegamos o ID do círculo
        console.log("ID do círculo sendo editado:", circleId);

        try {
          // Atualizar o círculo no banco de dados via API
          await api.put(`/panel/update/circle/map`, {
            radius: _mRadius,      // O novo raio
            lat: _latlng.lat,      // A nova latitude
            lng: _latlng.lng,      // A nova longitude
            id: circleId,
          });
          console.log('Círculo atualizado com sucesso:', circleId);
        } catch (error) {
          console.error('Erro ao atualizar o círculo:', error);
        }
      } else {
        console.log("Este layer não é um círculo ou não tem ID.");
      }
    });
  };
  const onEditStart = (e) => {
    const layers = e.layers || e.target; // Captura as camadas ou o alvo que está sendo editado

    layers.eachLayer((layer) => {
      if (layer instanceof L.Circle && layer.options.id !== undefined) {
        // Verifica se o layer é um círculo e tem um ID atribuído
        const circleId = layer.options.id;
        console.log("Iniciando edição do círculo com ID:", circleId);
      } else {
        console.log("Este layer não é um círculo ou não tem ID.");
      }
    });
  };
  const onCreated = (e) => {
    setLayer(e.layer);
    setModalState(true);


  };
  const handleOptionSelect = async (selectedOption) => {
    setOption(selectedOption);
    setModalState(false);

    if (layer) {
      const { _latlng, _mRadius } = layer;

      // Criar um marcador para a caixa com inputs
      const boxMarker = L.marker([_latlng.lat, _latlng.lng + 0.002], { // Ajuste a posição conforme necessário
        icon: L.divIcon({
          className: 'caixa',
          html: `
            <div class="caixa-conteudo">
            <div>
              <input type="text" placeholder="Custo frete " class="input-caixa" onclick/>
              <input type="text" placeholder="Dias adicionais " class="input-caixa" />
              <div>            
              </div>
          `,
        }),
      });

      const marker = L.marker(_latlng, {
        icon: L.divIcon({ className: selectedOption === 1 ? 'custom-icon' : 'custom_icon_jadlog' }),
      });
      marker.bindPopup(selectedOption === 1 ? "Flex" : "Jadlog").openTooltip();

      // Verifica se a referência do FeatureGroup está disponível antes de adicionar o marcador
      if (featureGroupRef.current) {
        featureGroupRef.current.addLayer(boxMarker);
        featureGroupRef.current.addLayer(marker);
      }

      try {
        const fetchedCeps = await fetchCepsInRadius(_latlng, _mRadius, selectedOption);
        setCeps(fetchedCeps);

        // Salva a localização e a opção escolhida no localStorage
        saveLocation(_latlng, _mRadius, selectedOption);
      } catch (error) {
        console.error('Erro ao buscar CEPs:', error);
      }
    }
  };
  const fetchCepsInRadius = async (latlng, radius, selectedOption) => {
    const { lat, lng } = latlng;

    const response = await api.post("/panel/storage/map", {
      lat: lat,
      lng: lng,
      type_delivery: selectedOption,
      radius: radius,
    })

    if(response.status == 200){
      loadSavedLocations()
    }

  };
  const saveLocation = (latlng, radius, option) => {
    const data = {
      latitude: latlng.lat,
      longitude: latlng.lng,
      radius: radius,
      deliveryOption: option,
    };

    // Armazena os dados no localStorage
    localStorage.setItem('userLocation', JSON.stringify(data));
    console.log('Dados salvos no localStorage:', data);
  };


  window.reactOnChangeHandler = (event, inputType, lat, lng, id) => {
    const value = event.target.value;

    if (inputType === 'custoFrete') {

      api.put("panel/update/map/", {
        lat: lat,
        lng: lng,
        id: id,
        coust_delivery: String(value).replace(",","."),
      })

      console.log(`Custo de Frete para [${lat}, ${lng}]:`, value);
      // Atualizar o estado correspondente no React, por exemplo:
      // setFrete({ lat, lng, value });
    } else if (inputType === 'diasAdicionais') {

      api.put("panel/update/map/", {
        lat: lat,
        lng: lng,
        id: id,
        adicional_days: value,
      })

      console.log(`Dias Adicionais para [${lat}, ${lng}]:`, value);
      // Atualizar o estado correspondente no React, por exemplo:
      // setDiasAdicionais({ lat, lng, value });
    }
  };
  window.removeCircle = async (circleId) => {
    try {
      // Deletar o círculo no banco de dados
      await api.delete(`/panel/delete/circle/map/${circleId}`);
      console.log(`Círculo com ID ${circleId} removido com sucesso!`);
  
      // Remover a camada correspondente do FeatureGroup
      if (featureGroupRef.current) {
        const layers = featureGroupRef.current.getLayers();
        layers.forEach((layer) => {
          // Remover o círculo
          if (layer instanceof L.Circle && layer.options.id === circleId) {
            featureGroupRef.current.removeLayer(layer);
          }
  
          // Remover o marcador associado ao círculo
          if (layer instanceof L.Marker && layer.options.id === circleId) {
            featureGroupRef.current.removeLayer(layer);
          }
        });
      }
        
      const boxRemoveButtonCircleElement = document.querySelector(`.btn-remove-circle-${circleId}`)

      if(boxRemoveButtonCircleElement){
        boxRemoveButtonCircleElement.remove()
        
      }
      
      const boxElementMaker = document.getElementById(`data-maker-${circleId}`); // Usando o id
      if (boxElementMaker) {
        boxElementMaker.remove(); // Remove a div da caixa
        console.log(`Caixa com ID data-maker-${circleId} removida com sucesso!`);
      }
      
      const boxElement = document.querySelector(`.caixa-${circleId}`);
      if (boxElement) {
        boxElement.remove(); // Remove a div da caixa
        console.log(`Caixa com ID ${circleId} removida com sucesso!`);
      }
   
    } catch (error) {
      console.error(`Erro ao remover o círculo com ID ${circleId}:`, error);
    }
  };

  
  const loadSavedLocations = async () => {
    try {
      const response = await api.get('/panel/get/maps');
      const locations = response.data;
      addLayerToMap(locations);
      setLoading(false); // Atualiza o estado de carregamento
    } catch (error) {
      console.error('Erro ao carregar locais salvos:', error);
    }
  };

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          setUserLocation([latitude, longitude]);
        },
        () => setUserLocation([-14.235004, -51.92528]) // Localização padrão
      );
    } else {
      setUserLocation([-14.235004, -51.92528]); // Localização padrão
    }
  }, []);

  useEffect(() => {
    if (userLocation) {
      loadSavedLocations(); // Carregar locais após a localização do usuário ser definida
    }
  }, [userLocation]);



  return (
    <div>
      {userLocation ? (
        <MapContainer
        axBounds={brazilBounds} // Limita o mapa ao Brasil
        maxBoundsViscosity={1.0} // Quão "pegajosa" é a restrição, 1.0 significa que o mapa não sai desses limites
          center={defaultCenter}
          zoom={5}
          attributionControl={true}
          style={{ height: '100vh', width: '100%' }}
          whenCreated={(mapInstance) => (mapRef.current = mapInstance)}
        >
          <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
          <FeatureGroup ref={featureGroupRef}>
            <EditControl
              position="topright"
              onCreated={onCreated}
              

              onEditStart={onEditStart}
              onEdited={onEdited}  // Lida com a atualização do raio do círculo
              draw={{
                rectangle: false,
                polygon: false,
                polyline: false,
                circlemarker: false,

                marker: false,
                circle: true, // Permite a criação de círculos
              }}
              edit={{
                featureGroup: featureGroupRef.current,
                remove: false, // Desabilita a opção de remover camadas (lixeira)

              }}
            />
          </FeatureGroup>
        </MapContainer>
      ) : (
        <p>Obtendo localização...</p>
      )}

      <Modal show={modalState} size="md" centered>
        <Modal.Header>
          <Modal.Title>Informe o tipo de entrega</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Button variant="primary" style={{ marginRight: "0.6rem", width: "90px" }} onClick={() => {handleOptionSelect(1)}}>
            Flex
          </Button>
          <Button variant="secondary" style={{ width: "90px" }} onClick={() => handleOptionSelect(2)}>
            Jadlog
          </Button>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => setModalState(false)}>Fechar</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Maps;
